module.exports = __webpack_public_path__ + "static/media/yoga.03a6f093.png";